module.exports = __webpack_public_path__ + "img/na-whatif-adjusters-screen.a7bc4d21.png";